import { __assign, __awaiter, __generator, __spreadArray } from "tslib";
import { assertFunction, assertString } from "../helpers/assertFunctions";
import { Event } from "../event/Event";
/**
 * 转换字符串为真实类型
 * @param str 任意字符串
 */
export function stringToType(str) {
    assertString(str);
    if (str === "true")
        return true;
    if (str === "false")
        return false;
    if (str === "null")
        return null;
    if (str === "undefined")
        return undefined;
    if (str === +str + "") {
        return +str;
    }
    return str;
}
/**
 * 判断是否是绝对地址
 * @param url
 */
export function isAbsoluteUrl(url) {
    return /^https?:|^\/\//.test(url);
}
/**
 * 将参数字典转换成 query string
 * @param o 参数字典
 * @param withQuestionMark 是否包含 ? 前缀
 */
export function toQueryString(o, withQuestionMark) {
    if (withQuestionMark === void 0) { withQuestionMark = true; }
    var queryString = [];
    if (!o)
        return "";
    Object.keys(o).forEach(function (key) {
        // @ts-ignore
        queryString.push(key + "=" + encodeURIComponent(o[key]));
    });
    return (withQuestionMark ? "?" : "") + queryString.join("&");
}
export function getLocation(url) {
    // @ts-ignore
    return url || window.location.href;
}
/**
 * 从字符串中读取前端路由地址
 * @param str 任意字符串，通常是 location.href
 */
export function getUrlRoute(str) {
    if (str.indexOf("/") === 0)
        return str;
    if (str.indexOf("#!/") > -1) {
        return str.substr(str.indexOf("#!/") + 2);
    }
    if (str.indexOf("#/") > -1) {
        return str.substr(str.indexOf("#/") + 1);
    }
    if (str.indexOf("#") > -1) {
        return str.substr(str.indexOf("#") + 1);
    }
}
/**
 * 获取字符串中的 query string 参数
 * @param url URL 地址
 */
export function queryStringToMap(url) {
    var _a = getLocation(url).split(/#!?/), normalQS = _a[0], hashQS = _a[1];
    return Object.assign(parseQueryString(normalQS), parseQueryString(hashQS));
}
export function parseQueryString(search) {
    if (!search)
        return {};
    var searchIndex = search.lastIndexOf("?");
    var paramString = search.substr(searchIndex + 1);
    var params = paramString.split("&");
    if (searchIndex < 0 || paramString === "" || params.length < 1) {
        return {};
    }
    return params.reduce(function (pre, curr) {
        var _a;
        var hasValue = curr.indexOf("=") > -1;
        var _b = curr.split("="), key = _b[0], value = _b[1];
        // ?a=  {a: ''}
        // ?a   {a: undefined}
        var val = hasValue && !value ? "" : !value ? value : stringToType(value);
        return __assign(__assign({}, pre), (_a = {}, _a[key] = val, _a));
    }, {});
}
/**
 * 过滤数组中重复集合
 * @param arr
 */
export function filterUnique(arr) {
    return arr.filter(function (value, index, items) {
        return items.indexOf(value) === index;
    });
}
/**
 * 返回 min~max 范围内 n 个随机整数
 * @param min 最小值
 * @param max 最大值
 * @param n 个数
 */
export function randomInts(min, max, n) {
    if (n === void 0) { n = 1; }
    return Array.from({ length: n }, function () {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    });
}
/**
 * 基于事件队列的去抖函数
 * @param fn 执行函数
 * @param ms 延迟时间
 */
export function debounceRequest(fn, ms) {
    if (ms === void 0) { ms = 200; }
    var timeout;
    var queue = [];
    var event = new Event();
    return function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var callback = args.pop();
        assertFunction(callback);
        var url = args[0];
        if (args.length === 2) {
            // ensure abs url
            url = (isAbsoluteUrl(args[0]) ? args[0] : window.API_DOMAIN + args[0])
                + toQueryString(args[1]);
        }
        queue.push(url);
        event.on(url, callback);
        if (timeout)
            clearTimeout(timeout);
        timeout = setTimeout(function () {
            try {
                // @ts-ignore
                fn.apply(_this, [__spreadArray([], queue), event]);
            }
            finally {
                queue = [];
            }
        }, ms);
    };
}
export function delay(ms) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve) {
                    setTimeout(resolve, ms);
                })];
        });
    });
}
